import {AbstractFilter} from '@gongxigames/framework/slot';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class ScatterAnticipatorFilter extends AbstractFilter {
    protected scatterNeeded: number;
    protected scatterIndexFromMath: number;

    constructor(name: string, scatterNeeded: number, scatterIndexFromMath: number) {
        super(name);
        this.scatterNeeded = scatterNeeded;
        this.scatterIndexFromMath = scatterIndexFromMath;
    }

    public filter(response: Message, session: Session): boolean {
        const action = response.getAction();

        if (action !== Action.SPIN && action !== Action.FREESPIN && action !== Action.RESPIN && action !== Action.MINISPIN) {
            return true;
        }
        const spin = this.getSpin(response);
        let scatterAmount = 0;

        spin.symbolIds.forEach(reel => {
            reel.forEach(symbol => {
                if (symbol === this.scatterIndexFromMath) {
                    scatterAmount++;
                }
            });
        });

        if (this.scatterNeeded === scatterAmount) {
            return true;
        }

        return false;
    }
}
